var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "b-card-actions",
        { attrs: { title: "Notas fiscais de quebra" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [
                  _c("b-table", {
                    ref: "invoiceReferences",
                    staticClass: "bordered",
                    attrs: {
                      "show-empty": "",
                      striped: "",
                      fields: _vm.fields,
                      items: _vm.invoiceReferences,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(action)",
                        fn: function (row) {
                          return [
                            _c("e-grid-actions", {
                              attrs: {
                                "show-update": false,
                                "show-delete": false,
                                buttons: _vm.gridButtons(row),
                              },
                              on: {
                                "consult-invoice": function ($event) {
                                  return _vm.onUpdateInvoice(row.item)
                                },
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "cell(status)",
                        fn: function (row) {
                          return [
                            _c("e-status-badge", {
                              attrs: {
                                status: row.item.status,
                                options: _vm.statusInvoiceOptions(),
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }